"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Date = _interopRequireDefault(require("wix-ui-icons-common/Date"));

var _Input = _interopRequireDefault(require("../../Input"));

var _legacyParse = _interopRequireDefault(require("../../common/LocaleUtils/legacyParse"));

var _context = require("../../WixStyleReactEnvironmentProvider/context");

var _wixDesignSystemsLocaleUtils = require("wix-design-systems-locale-utils");

var _excluded = ["value", "customInput", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DateInput = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(DateInput, _React$PureComponent);

  var _super = _createSuper(DateInput);

  function DateInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, DateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_formatDateValue", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          dateStyle = _this$props.dateStyle;

      var locale = _this._getLocale();

      if (!value) {
        return '';
      }

      if (typeof value === 'string') {
        return value;
      }

      if (dateStyle === 'medium') {
        return _wixDesignSystemsLocaleUtils.dateTimeFormat.getMediumDate(locale, value);
      }

      return _wixDesignSystemsLocaleUtils.dateTimeFormat.getShortDate(locale, value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleInputChange", function (event) {
      var onChange = _this.props.onChange;
      var val = event.target.value;
      var dateObjectFormat = (0, _legacyParse["default"])(val);
      var newVal = {
        dateVal: !isNaN(dateObjectFormat) ? dateObjectFormat : new Date(),
        textVal: val
      };
      onChange(newVal);
    });
    return _this;
  }

  (0, _createClass2["default"])(DateInput, [{
    key: "_getLocale",
    value: function _getLocale() {
      return this.props.locale || this.context.locale || 'en';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          initialValue = _this$props2.value,
          customInput = _this$props2.customInput,
          onChange = _this$props2.onChange,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);

      var _inputProps = _objectSpread(_objectSpread({
        focusOnClearClick: false,
        value: this._formatDateValue(),
        prefix: /*#__PURE__*/_react["default"].createElement(_Input["default"].IconAffix, {
          dataHook: "date-input-date-icon"
        }, /*#__PURE__*/_react["default"].createElement(_Date["default"], null)),
        autoSelect: false,
        onChange: this._handleInputChange
      }, rest), customInput ? customInput.props : {});

      return /*#__PURE__*/_react["default"].cloneElement(customInput || /*#__PURE__*/_react["default"].createElement(_Input["default"], null), _inputProps);
    }
  }]);
  return DateInput;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(DateInput, "displayName", 'DateInput');
DateInput.contextType = _context.WixStyleReactEnvironmentContext;
DateInput.propTypes = _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  /** The selected date */
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),

  /** Instance locale */
  locale: _propTypes["default"].oneOf(_wixDesignSystemsLocaleUtils.supportedWixlocales),

  /** Sets date format of locale */
  dateStyle: _propTypes["default"].oneOf(['short', 'medium'])
});
var _default = DateInput;
exports["default"] = _default;